import { render, staticRenderFns } from "./orderDeliver.vue?vue&type=template&id=a1f149cc&scoped=true"
import script from "./orderDeliver.vue?vue&type=script&lang=js"
export * from "./orderDeliver.vue?vue&type=script&lang=js"
import style0 from "./orderDeliver.vue?vue&type=style&index=0&id=a1f149cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1f149cc",
  null
  
)

export default component.exports